import { SpaceContext } from '@eggplant/context'
import {
  useContext,
  type MouseEvent
} from 'react'
import usePreventLeaveSpace from '../CustomPreventNavigate/usePreventLeaveSpace'
import StyledLink from '../StyledLink'
import {
  ACCESS,
  SYSTEM
} from '../routes'
import type { Props } from '../types'

const LinkToAccess = ({
  children,
  isHyperlink
}: Props) =>{
  const navTo = `/${SYSTEM}/${ACCESS}`
  const spaceContext = useContext(SpaceContext)

  const {
    getLeaveSpaceConfirmation,
    Confirmation
  } = usePreventLeaveSpace({
    navTo
  })

  const handleClick = (event: MouseEvent) => {
    if (spaceContext && spaceContext.selectedSpaceId) {
      event.preventDefault()
      void getLeaveSpaceConfirmation()
    }
  }

  return (
    <>
      <StyledLink
        isHyperlink={isHyperlink}
        onClick={handleClick}
        to={navTo}
      >
        {children}
      </StyledLink>
      {
        spaceContext && spaceContext.selectedSpaceId &&
          <Confirmation />
      }
    </>
  )
}

export default LinkToAccess
